import React, { useEffect, useState } from 'react'
import {Navbar, NavbarBrand, NavbarMenuToggle, NavbarMenu, NavbarMenuItem, NavbarContent, NavbarItem, Link, Button} from "@heroui/react";
import { db } from '../../Firebase/firebase';
import LOGO from "../Fotos/LOGO.png"
import { NavLink } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore';
import { generarId } from '../Helpers/generarId';
import useAuth from '../Helpers/useAuth';

const NavBar = () => {
  const [menuisActive, setMenuIsActive] = useState(false);
  const { user, isAuthenticated, logout, getUserData } = useAuth();

  // Registrar entrada del usuario
  useEffect(() => {
    if (user?.uid && isAuthenticated) {
      setDoc(doc(db, "registroDeEntradas", user.uid), {[generarId()]: new Date()}, {merge: true})
        .catch(error => console.error('Error registrando entrada:', error));
    }
  }, [user, isAuthenticated]);

  // No mostrar navbar si no está autenticado
  if (!isAuthenticated) {
    return null;
  }

  const userData = getUserData();

  return (
    <Navbar 
      className='from-gray-900 to-sky-900 bg-gradient-to-t text-white' 
      disableAnimation 
      isBordered 
      isBlurred 
      //shouldHideOnScroll 
      onMenuOpenChange={(e) => setMenuIsActive(e)} 
      isMenuOpen={menuisActive}
    >
      <NavbarContent className="sm:hidden" justify="start">
        <NavbarMenuToggle />
      </NavbarContent>

      <NavbarContent className="sm:hidden pr-3" justify="center">
        <NavbarBrand className='w-28'>
          {/*<img src={LOGO} alt="Logo" />*/}
          <span className='text-lg font-bold'>Wachalo.co</span>
        </NavbarBrand>
      </NavbarContent>

      <NavbarContent className="hidden sm:flex gap-4" justify="center">
        <NavbarBrand className="w-28">
          {/*<img className="" src={LOGO} alt="Logo" />*/}
          <span className='text-lg font-bold'>Wachalo.co</span>
        </NavbarBrand>
        

        <NavbarItem>
          <NavLink color="foreground" to="/configurar-perfil">
            <div className='flex flex-col items-center hover:text-blue-300 transition-colors'>
              <span className="text-xl">👤</span>
              <label className='text-xs'>Mi Perfil</label>
            </div>
          </NavLink>
        </NavbarItem>
      </NavbarContent>

      <NavbarContent justify="end">
        {/* Mostrar información del usuario */}
        <NavbarItem className="hidden sm:flex">
          <div className='flex items-center gap-2 mr-4'>
            <div className='w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center'>
              <span className='text-white text-sm font-bold'>
                {userData.nombre ? userData.nombre.charAt(0).toUpperCase() : userData.email?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div className='flex flex-col'>
              <span className='text-xs text-gray-300'>
                {userData.nombre || 'Usuario'}
              </span>
              <span className='text-xs text-gray-400'>
                {userData.email}
              </span>
            </div>
          </div>
        </NavbarItem>

        <NavbarItem>
          <button 
            onClick={logout} 
            className="rounded-md px-3 py-1 text-white gap-2 font-semibold text-sm flex items-center hover:bg-red-600 transition-colors"
          >
            <i className="fa-solid fa-sign-out-alt"></i>
            Cerrar sesión
          </button>
        </NavbarItem>
      </NavbarContent>

      <NavbarMenu>
        {/* Información del usuario en el menú móvil */}
        <NavbarMenuItem className="border-b border-gray-700 pb-4 mb-4">
          <div className='flex items-center gap-3'>
            <div className='w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center'>
              <span className='text-white font-bold'>
                {userData.nombre ? userData.nombre.charAt(0).toUpperCase() : userData.email?.charAt(0).toUpperCase()}
              </span>
            </div>
            <div className='flex flex-col'>
              <span className='text-sm font-medium'>
                {userData.nombre || 'Usuario'}
              </span>
              <span className='text-xs text-gray-500'>
                {userData.email}
              </span>
            </div>
          </div>
        </NavbarMenuItem>

        <NavbarMenuItem onClick={() => setMenuIsActive(false)}>
          <NavLink color="foreground" to="/links">
            <div className='flex items-center gap-4 py-2 hover:text-blue-300 transition-colors'>
              <span className="text-xl">🔗</span>
              <label>Links</label>
            </div>
          </NavLink>
        </NavbarMenuItem>

        <NavbarMenuItem onClick={() => setMenuIsActive(false)}>
          <NavLink color="foreground" to="/configurar-perfil">
            <div className='flex items-center gap-4 py-2 hover:text-blue-300 transition-colors'>
              <span className="text-xl">👤</span>
              <label>Mi Perfil</label>
            </div>
          </NavLink>
        </NavbarMenuItem>

        <NavbarMenuItem onClick={() => setMenuIsActive(false)}>
          <NavLink color="foreground" to="/prestamos/informacion">
            <div className='flex items-center gap-4 py-2 hover:text-blue-300 transition-colors'>
              <i className="fa-solid fa-building-user text-xl"></i>
              <label>Prestamos</label>
            </div>
          </NavLink>
        </NavbarMenuItem>

        <NavbarMenuItem onClick={() => setMenuIsActive(false)}>
          <NavLink color="foreground" to="/bancas/resumen">
            <div className='flex items-center gap-4 py-2 hover:text-blue-300 transition-colors'>
              <i className="fa-solid fa-vault text-xl"></i>
              <label>Bancas</label>
            </div>
          </NavLink>  
        </NavbarMenuItem>

        {/* Botón de cerrar sesión en menú móvil */}
        <NavbarMenuItem className="mt-4 pt-4 border-t border-gray-700">
          <button 
            onClick={() => {
              setMenuIsActive(false);
              logout();
            }}
            className="w-full flex items-center gap-4 py-2 text-red-400 hover:text-red-300 transition-colors"
          >
            <i className="fa-solid fa-sign-out-alt text-xl"></i>
            <label>Cerrar sesión</label>
          </button>
        </NavbarMenuItem>
      </NavbarMenu>
    </Navbar>
  );
};

export default NavBar;